import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import formStyles from "../CheckoutForms.module.scss";
import SelectDropDown from "../selectDropDown/SelectDropDown";

const BillingAddress = ({
  formName,
  variant,
  validations,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  addressTypesOptions,
  stateTypesOptions,
  onChangeHandler,
  onBlurHandler,
  showBillingAddress,
  containerClassName,
  rowClassName,
}) => {
  const BUSINESS_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[1]
      ? addressTypesOptions[1].id
      : "";
  const POSTAL_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[2]
      ? addressTypesOptions[2].id
      : "";

  const labels = {
    default: {
      unitNo: "Unit no.",
      complexName: "Complex name",
      mobUnitNo: "Unit no. & Complex name",
      optional: " (Optional)",
    },
    business: {
      unitNo: "Unit / Floor no.",
      complexName: "Office park / Building name",
      mobUnitNo: "Unit / Floor no. & Office park / Building name",
      optional: " (Optional)",
    },
  };

  const selectedLables =
    fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE
      ? labels.business
      : labels.default;

  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  const handleDropdown = (event, val = null, formName) => {
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return (
    <CustomContainer
      className={`${formStyles[variant]} ${formStyles["main-container"]}  ${containerClassName}`}
    >
      <Form.Row className={`${formStyles["main-row"]} ${rowClassName}`}>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
        >
          <Form.Check
            custom
            name="addressCheck"
            label="My billing address is the same as my delivery address"
            checked={fieldValues["addressCheck"]}
            onChange={handleChange}
            onBlur={handleBlur}
            className={formStyles["form-checkbox-label"]}
            id={`validationFormikba112-${variant}-${formName}`}
          />
        </Form.Group>
        {showBillingAddress && (
          <>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormba101-${variant}-${formName}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormba101-label-${variant}-${formName}`}
              >
                Address name
              </Form.Label>
              <Form.Control
                type="text"
                name="addressName"
                value={fieldValues["addressName"]}
                placeholder="Add address name"
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues["addressName"]}
                isInvalid={fieldErrors["addressName"]}
                className={
                  fieldErrors["addressName"] ? formStyles["invalid"] : ""
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["addressName"]}
              </Form.Control.Feedback>
              {!fieldErrors["addressName"] && (
                <div className={formStyles["hint-text"]}>
                  {"What you normally call this address (e.g. Home)"}
                </div>
              )}
            </Form.Group>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormba102-${variant}-${formName}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormba102-label-${variant}-${formName}`}
              >
                Address type
              </Form.Label>
              <SelectDropDown
                formName={formName}
                name="addressType"
                label="Address Type"
                data={addressTypesOptions}
                handleSelect={handleDropdown}
                selectedId={fieldValues["addressType"]}
                customId={`validationFormba102-${variant}-${formName}`}
                fieldError={fieldErrors["addressType"]}
              />
            </Form.Group>

            {fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE && (
              <>
                <Form.Group
                  as={Col}
                  sm="12"
                  md="12"
                  className={formStyles["form-group"]}
                  controlId={`validationFormba113-${variant}-${formName}`}
                >
                  <Form.Label
                    className={formStyles["form-label"]}
                    id={`validationFormba113-label-${variant}-${formName}`}
                  >
                    Company name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName"
                    value={fieldValues["companyName"]}
                    placeholder="Add company name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    readOnly={readOnlyValues["companyName"]}
                    isInvalid={fieldErrors["companyName"]}
                    className={
                      fieldErrors["companyName"] ? formStyles["invalid"] : ""
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={formStyles["invalid-feedback"]}
                  >
                    {fieldErrorsMessage["companyName"]}
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            )}
            {fieldValues["addressType"] == POSTAL_ADDRESS_TYPE && (
              <>
                <Form.Group
                  as={Col}
                  sm="12"
                  md="12"
                  className={formStyles["form-group"]}
                  controlId={`validationFormba111-${variant}-${formName}`}
                >
                  <Form.Label
                    className={formStyles["form-label"]}
                    id={`validationFormba111-label-${variant}-${formName}`}
                  >
                    Address line 1
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine1"
                    placeholder="#"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    readOnly={readOnlyValues["addressLine1"]}
                    isInvalid={fieldErrors["addressLine1"]}
                    className={
                      fieldErrors["addressLine1"] ? formStyles["invalid"] : ""
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={formStyles["invalid-feedback"]}
                  >
                    {fieldErrorsMessage["addressLine1"]}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  sm="12"
                  md="12"
                  className={formStyles["form-group"]}
                  controlId={`validationFormba112-${variant}-${formName}`}
                >
                  <Form.Label
                    className={formStyles["form-label"]}
                    id={`validationFormba112-label-${variant}-${formName}`}
                  >
                    Address line 2
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine2"
                    placeholder="#"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    readOnly={readOnlyValues["addressLine2"]}
                    isInvalid={fieldErrors["addressLine2"]}
                    className={
                      fieldErrors["addressLine2"] ? formStyles["invalid"] : ""
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={formStyles["invalid-feedback"]}
                  >
                    {fieldErrorsMessage["addressLine2"]}
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            )}

            {fieldValues["addressType"] !== POSTAL_ADDRESS_TYPE && (
              <>
                <Form.Row className={formStyles["form-row"]}>
                  <Form.Label
                    className={`d-block d-sm-none ${formStyles["form-label"]}`}
                    id={`validationFormba103-mob-label-${variant}-${formName}`}
                  >
                    {selectedLables.mobUnitNo}
                    {!validations["unitNo"] && !validations["complexName"] && (
                      <span>{selectedLables.optional}</span>
                    )}
                  </Form.Label>
                  <Form.Group
                    as={Col}
                    xs="4"
                    sm="4"
                    md="4"
                    className={formStyles["form-group"]}
                    controlId={`validationFormba103-${variant}-${formName}`}
                  >
                    <Form.Label
                      className={`d-none d-sm-block ${formStyles["form-label"]}`}
                      id={`validationFormba103-label-${variant}-${formName}`}
                    >
                      {selectedLables.unitNo}
                      {!validations["unitNo"] && (
                        <span>{selectedLables.optional}</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="unitNo"
                      value={fieldValues["unitNo"]}
                      placeholder="#"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      readOnly={readOnlyValues["unitNo"]}
                      isInvalid={fieldErrors["unitNo"]}
                      className={
                        fieldErrors["unitNo"] ? formStyles["invalid"] : ""
                      }
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className={formStyles["invalid-feedback"]}
                    >
                      {fieldErrorsMessage["unitNo"]}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    xs="8"
                    sm="8"
                    md="8"
                    className={formStyles["form-group"]}
                    controlId={`validationFormba104-${variant}-${formName}`}
                  >
                    <Form.Label
                      className={`d-none d-sm-block ${formStyles["form-label"]}`}
                      id={`validationFormba104-label-${variant}-${formName}`}
                    >
                      {selectedLables.complexName}
                      {!validations["complexName"] && (
                        <span>{selectedLables.optional}</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="complexName"
                      value={fieldValues["complexName"]}
                      placeholder="Add complex name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      readOnly={readOnlyValues["complexName"]}
                      isInvalid={fieldErrors["complexName"]}
                      className={
                        fieldErrors["complexName"] ? formStyles["invalid"] : ""
                      }
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className={formStyles["invalid-feedback"]}
                    >
                      {fieldErrorsMessage["complexName"]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>

                <Form.Row className={formStyles["form-row"]}>
                  <Form.Label
                    className={`d-block d-sm-none ${formStyles["form-label"]}`}
                    id={`validationFormba105-mob-label-${variant}-${formName}`}
                  >
                    Street no. & Street name
                    {!validations["streetNo"] && validations["streetName"] && (
                      <span>{selectedLables.optional}</span>
                    )}
                  </Form.Label>
                  <Form.Group
                    as={Col}
                    xs="4"
                    sm="4"
                    md="4"
                    className={formStyles["form-group"]}
                    controlId={`validationFormba105-${variant}-${formName}`}
                  >
                    <Form.Label
                      className={`d-none d-sm-block ${formStyles["form-label"]}`}
                      id={`validationFormba105-label-${variant}-${formName}`}
                    >
                      Street no.
                      {!validations["streetNo"] && (
                        <span>{selectedLables.optional}</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="streetNo"
                      value={fieldValues["streetNo"]}
                      placeholder="#"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      readOnly={readOnlyValues["streetNo"]}
                      isInvalid={fieldErrors["streetNo"]}
                      className={
                        fieldErrors["streetNo"] ? formStyles["invalid"] : ""
                      }
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className={formStyles["invalid-feedback"]}
                    >
                      {fieldErrorsMessage["streetNo"]}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    xs="8"
                    sm="8"
                    md="8"
                    className={formStyles["form-group"]}
                    controlId={`validationFormba106-${variant}-${formName}`}
                  >
                    <Form.Label
                      className={`d-none d-sm-block ${formStyles["form-label"]}`}
                      id={`validationFormba106-label-${variant}-${formName}`}
                    >
                      Street name
                      {!validations["streetName"] && (
                        <span>{selectedLables.optional}</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="streetName"
                      value={fieldValues["streetName"]}
                      placeholder="Add street name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      readOnly={readOnlyValues["streetName"]}
                      isInvalid={fieldErrors["streetName"]}
                      className={
                        fieldErrors["streetName"] ? formStyles["invalid"] : ""
                      }
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className={formStyles["invalid-feedback"]}
                    >
                      {fieldErrorsMessage["streetName"]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
              </>
            )}
            <Form.Row className={formStyles["form-row"]}>
              <Form.Label
                className={`d-block d-sm-none ${formStyles["form-label"]}`}
                id={`validationFormba107-mob-label-${variant}-${formName}`}
              >
                Suburb & Postal code
              </Form.Label>
              <Form.Group
                as={Col}
                xs="8"
                sm="8"
                md="8"
                className={formStyles["form-group"]}
                controlId={`validationFormba107-${variant}-${formName}`}
              >
                <Form.Label
                  className={`d-none d-sm-block ${formStyles["form-label"]}`}
                  id={`validationFormba107-label-${variant}-${formName}`}
                >
                  Suburb
                </Form.Label>
                <Form.Control
                  type="text"
                  name="suburb"
                  value={fieldValues["suburb"]}
                  placeholder="Add suburb"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  readOnly={readOnlyValues["suburb"]}
                  isInvalid={fieldErrors["suburb"]}
                  className={fieldErrors["suburb"] ? formStyles["invalid"] : ""}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className={formStyles["invalid-feedback"]}
                >
                  {fieldErrorsMessage["suburb"]}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                xs="4"
                sm="4"
                md="4"
                className={formStyles["form-group"]}
                controlId={`validationFormba108-${variant}-${formName}`}
              >
                <Form.Label
                  className={`d-none d-sm-block ${formStyles["form-label"]}`}
                  id={`validationFormba108-label-${variant}-${formName}`}
                >
                  Postal code
                </Form.Label>
                <Form.Control
                  type="text"
                  name="postalCode"
                  value={fieldValues["postalCode"]}
                  placeholder="#"
                  maxLength="4"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  readOnly={readOnlyValues["postalCode"]}
                  isInvalid={fieldErrors["postalCode"]}
                  className={
                    fieldErrors["postalCode"] ? formStyles["invalid"] : ""
                  }
                />
                <Form.Control.Feedback
                  type="invalid"
                  className={formStyles["invalid-feedback"]}
                >
                  {fieldErrorsMessage["postalCode"]}
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormba109-${variant}-${formName}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormba109-label-${variant}-${formName}`}
              >
                Town / City
              </Form.Label>
              <Form.Control
                type="text"
                name="town"
                value={fieldValues["town"]}
                placeholder="Add town / city"
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues["town"]}
                isInvalid={fieldErrors["town"]}
                className={fieldErrors["town"] ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["town"]}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormba110-${variant}-${formName}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormba110-label-${variant}-${formName}`}
              >
                Province
              </Form.Label>
              <SelectDropDown
                formName={formName}
                name="province"
                label="Province"
                data={stateTypesOptions}
                handleSelect={handleDropdown}
                selectedId={fieldValues["province"]}
                customId={`validationFormba110-${variant}-${formName}`}
                fieldError={fieldErrors["province"]}
              />
            </Form.Group>
            {/* 
        Don't delete it we will show it later
        
        {formName == "delivery" && status !== "change" && (
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormikba111-${variant}-${formName}`}
          >
            <Form.Label className={formStyles["form-label"]} id={`validationFormikba111-label-${variant}-${formName}`}>
              Any special instructions? <span>(Optional)</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              name="instructions"
              placeholder="e.g. Please call me when you're at the gate"
              value={fieldValues["instructions"]}
              className={formStyles["form-control-area"]}
              onChange={handleChange}
              onBlur={handleBlur}
              readOnly={readOnlyValues["instructions"]}
            ></Form.Control>
            <div className={formStyles["hint-text"]}>
              {"Deliveries are made on weekdays between 08:00 and 17:00"}
            </div>
          </Form.Group>
        )} */}
          </>
        )}
      </Form.Row>
    </CustomContainer>
  );
};

BillingAddress.propTypes = {
  variant: PropTypes.oneOf(["plain", "popup"]),
  formName: PropTypes.oneOf(["delivery", "billing"]),
  status: PropTypes.oneOf(["add", "edit", "change"]),
  validations: PropTypes.object,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  addressTypesOptions: PropTypes.array,
  stateTypesOptions: PropTypes.array,
  containerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  onBlurHandler: PropTypes.func,
};

BillingAddress.defaultProps = {
  variant: "plain",
  formName: "billing",
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: [],
};

export default BillingAddress;
